import {REDUCER_NAME} from './const';

export const selectOwnState = (state) => {
    return state[REDUCER_NAME];
};

export const selectSalesOrderPartialRefundList = (state) => {
    return selectOwnState(state).salesOrderList;
};

export const selectPartialRefund = (state) => {
    return selectOwnState(state).partialRefundData;
};

export const selectFetching = (state) => {
    return selectOwnState(state).fetching;
};

export const selectValidationMessageList = (state) => {
    return selectOwnState(state).validationMessageList;
};



// WEBPACK FOOTER //
// ./src/modules/partial-refund/state/selector.js